import { HTTP } from './_http';

const getContracts = (form) => {
	return new Promise((resolve, reject) => {
		return HTTP.post(`/Home/GetAgentContractsAsync`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getCorporateBranch = (form) => {
	return new Promise((resolve, reject) => {
		return HTTP.post(`/AutomaticAttendanceSystem/GetCorporateBranchAsync`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getEmployeeTransactionsAsync = (form) => {
	return new Promise((resolve, reject) => {
		return HTTP.post(`/AutomaticAttendanceSystem/EmployeeTransactionsAsync`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const printEmployeeTransactionsAsync = (form) => {
	return new Promise((resolve, reject) => {
		return HTTP.post(`/AutomaticAttendanceSystem/PrintEmployeeTransactionsAsync`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getUser = () => {
	return new Promise((resolve, reject) => {
		return HTTP.get('/Authentication/User')
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

export { getContracts, getCorporateBranch, getEmployeeTransactionsAsync, printEmployeeTransactionsAsync, getUser }